import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'number-4', 'Number4', [["path",{"d":"M15 20v-15l-8 11h10"}]]);